/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import {
  notificationSetting,
  notificationType,
  showNotification,
} from "../Common";
import { connectWallet } from "../Scripts/interact";
import useWalletChange from "../hooks/useWalletChange";

const TokenHolder = () => {
  const { isWalletConnected, changedAddress } = useWalletChange();

  const connectWalletPressed = async () => {
    const response = await connectWallet();

    if (response.status) {
      console.log("Wallet Connected");
    } else {
      showNotification(
        notificationType.DANGER,
        response.message,
        notificationSetting
      );
    }
  };

  return (
    <>
      <div className="banner-sec">
        <div className="container">
          <div className="in-pg-content text-center">
            <img src="assets/images/sc-logo.png" alt="" title="" className="sc-logo img-fluid" />
            <h2>
              Join our discord channel, connect your wallet, so you can Access
              Token Holders Only Channels
            </h2>
            {isWalletConnected ? (
              <button className="btn" disabled>
                Wallet Address:{" "}
                {`${changedAddress?.substring(
                  0,
                  5
                )}...${changedAddress?.substring(
                  changedAddress?.length - 4,
                  changedAddress?.length
                )}`}
              </button>
            ) : (
              <>
                <button
                  className="btn"
                  onClick={connectWalletPressed}
                >
                  CONNECT WALLET
                </button>
                <p>
                  Connect Your Wallet to Access Super Creators Token Holder
                  Benefits
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TokenHolder;
